import React from "react";

const EyeIcon = ({ className, size = 16, color = "#6E7784", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      d="M14.1568 6.7583C13.2815 5.2923 11.3167 2.83301 8.00006 2.83301C4.68339 2.83301 2.71865 5.2923 1.84332 6.7583C1.38532 7.52363 1.38532 8.47505 1.84332 9.24105C2.71865 10.707 4.68339 13.1663 8.00006 13.1663C11.3167 13.1663 13.2815 10.707 14.1568 9.24105C14.6148 8.47505 14.6148 7.5243 14.1568 6.7583ZM13.2987 8.7277C12.5321 10.0117 10.8234 12.1663 8.00006 12.1663C5.17672 12.1663 3.46806 10.0124 2.70139 8.7277C2.43339 8.27837 2.43339 7.72033 2.70139 7.271C3.46806 5.987 5.17672 3.83236 8.00006 3.83236C10.8234 3.83236 12.5321 5.98633 13.2987 7.271C13.5674 7.721 13.5674 8.27837 13.2987 8.7277ZM8.00006 5.16634C6.43739 5.16634 5.16672 6.43767 5.16672 7.99967C5.16672 9.56167 6.43739 10.833 8.00006 10.833C9.56272 10.833 10.8334 9.56167 10.8334 7.99967C10.8334 6.43767 9.56272 5.16634 8.00006 5.16634ZM8.00006 9.83301C6.98872 9.83301 6.16672 9.01101 6.16672 7.99967C6.16672 6.98834 6.98872 6.16634 8.00006 6.16634C9.01139 6.16634 9.83339 6.98834 9.83339 7.99967C9.83339 9.01101 9.01139 9.83301 8.00006 9.83301Z"
      fill={color}
    />
  </svg>
);

export default EyeIcon;
